import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

const LIST_ENDPOINT = '/activate';

interface ActivateResponse {
  error: boolean;
}

@Injectable()
export class ActivateService {
  constructor(private http: HttpClient) {}

  async activate(uid: string): Promise<boolean> {
    const response = await firstValueFrom(
      this.http.get<ActivateResponse>(`${environment.apiUrl}${LIST_ENDPOINT}/${uid}`)
    );

    return response.error;
  }
}